import state from './moduleCalendarManagementState.js'
import mutations from './moduleCalendarManagementMutations.js'
import actions from './moduleCalendarManagementActions.js'
import getters from './moduleCalendarManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

